import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface ITrashIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

export const TrashIcon = ({
    fill = 'currentcolor',
    size = 22,
    title,
    id = 'trash-icon',
}: ITrashIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_4745_11739)">
                    <path
                        d="M18.37 6.21916H14.3055V4.97248C14.3055 3.88804 13.426 3 12.333 3H9.01992C7.93548 3 7.04743 3.87951 7.04743 4.97248V6.21916H3V7.75616H4.40038V18.2248C4.40038 19.1641 5.16888 19.9326 6.10816 19.9326H15.1935C16.1328 19.9326 16.9013 19.1641 16.9013 18.2248V9.46394H15.1935V18.2248H6.10816V7.75616H18.37V6.21916ZM12.7685 6.21916H8.60151V4.97248C8.60151 4.73339 8.79791 4.537 9.02846 4.537H12.3415C12.5806 4.537 12.7685 4.73339 12.7685 4.97248V6.21916Z"
                        fill={fill}
                    />
                    <path d="M8.66127 10.463H7.12427V15.6547H8.66127V10.463Z" fill={fill} />
                    <path d="M11.4535 9.81403H9.9165V16.3121H11.4535V9.81403Z" fill={fill} />
                    <path d="M14.2372 10.463H12.7002V15.6547H14.2372V10.463Z" fill={fill} />
                </g>
                <defs>
                    <clipPath id="clip0_4745_11739">
                        <rect width="15.37" height="16.9326" fill="white" transform="translate(3 3)" />
                    </clipPath>
                </defs>
            </svg>
        </SIconSpan>
    )
}

export default TrashIcon
